module.exports = __webpack_public_path__ + "img/Link Icon - charcoal.d1870846.svg";